// extracted by mini-css-extract-plugin
export default {"button":"button-c05a","bg-blue":"bg-blue-e718"};